import React from 'react';
import { PropTypes as T } from 'prop-types';
import { Input } from 'reactstrap';

import BaseInput from '../base';

export default class BoundInput extends BaseInput {
  static defaultProps = {
    ...BaseInput.defaultProps,
    type: 'text',
  }

  static propTypes = {
    ...BaseInput.propTypes,
    type: T.string.isRequired,
    placeholder: T.string,
    multiple: T.bool,
  }

  render() {
    const {
      model,
      property,
      type,
      ...inputProps
    } = this.props;

    const name = inputProps.name || property;

    const checkedProps = { };
    if (this.state.value && type === 'checkbox') {
      checkedProps.checked = true;
    }

    return (
      <Input
        {...inputProps}
        {...checkedProps}
        value={this.state.value}
        name={name}
        type={type}
        onChange={e => this.update(e.target.value)}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./app/components/forms/input/bound_input/index.jsx